export const answersByTypeKeys = {
    all: ['answers-by-type'],
    inspection: (inspectionId) => [...answersByTypeKeys.all, inspectionId]
};
